import { useIsAuctionBidAllowedQuery } from '../data-access/queries';

type UseIsAuctionBidAllowedProps = {
	auctionId: string;
	/**
	 * Indicates if the product associated with the auction is scheduled but not active.
	 * Needed for preventing a 404 with the useIsAuctionBidAllowedQuery query.
	 */
	isProductActive: boolean;
};

export const useIsAuctionBidAllowed = ({ auctionId, isProductActive }: UseIsAuctionBidAllowedProps) => {
	const { data, isLoading } = useIsAuctionBidAllowedQuery(
		{ auctionId },
		{ enabled: Boolean(isProductActive) && Boolean(auctionId) }
	);

	return {
		/**
		 * Checks if bid is allowed taking into account if user already bidded on linked products and variants.
		 * */
		isBidAllowed: data?.biddable ?? false,
		isLoading
	};
};
